import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * WalmartError Component
 * Simple error page displayed when Walmart OAuth authentication fails
 * Matches existing HandleRedirection style for consistency
 */
const WalmartError = () => {
    const navigate = useNavigate();

    const handleRedirectionClick = () => {
        navigate('/marketplace-integration');
    };

    return (
        <main>
            <div className="main__container">
                <div className="cus-page-content-sec">
                    <div className="top_right_button_container cus-content-only-sec">
                        <div className='incoming_wrapper main_content_table addressDetailWrapper'>
                            <div className='statusRedirect error'>
                                <div className='icon error'>
                                    <i className="fa fa-times" aria-hidden="true"></i>
                                </div>
                                <h2 className='mb-10'>Access Denied</h2>
                                <p>Failed to connect your Walmart account. Please try again.</p>
                                <button 
                                    className="btn cus-primary-transparent-btn" 
                                    onClick={handleRedirectionClick}
                                >
                                    Back to Integration
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default WalmartError;
